
import { TopbarMenuComponent } from './topbar-menu/topbar-menu.component';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';

export const SHELL_COMPONENTS: any[] = [
    TopbarMenuComponent,
    SidebarMenuComponent
];
